import { AppBar, Box, styled } from '@/shared/ui';

export const StyledAppBar = styled(AppBar)(({ theme }) => ({
  backgroundColor: 'inherit',
  color: theme.palette.common.black,
  boxShadow: 'none',
}));

export const BalanceBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: theme.spacing(1),
  padding: theme.spacing(1, 2),
  height: 40,
}));

export const StyledHeaderContainer = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '20px 20px 30px 0px',
  height: '100%',
}));

export const StyledMainContentContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  flexGrow: 1,
}));
